"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpotUser = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SpotUser = _ref => {
  let {
    spotColor = "#C9DBFE",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fill: spotColor,
    fillRule: "evenodd",
    d: "M17.762 13.546c2.68.605 6.936 1.627 10.038 4.667 3.102 3.049 5.332 8.398 3.588 11.465-1.754 3.059-7.482 3.825-12.526 5.052-5.053 1.236-9.415 2.932-12.463 1.56-3.04-1.37-4.748-5.8-5.656-9.616-.917-3.816-1.016-7.01-.125-9.68.88-2.67 2.77-4.808 4.918-5.512 2.158-.694 4.586.037 6.502.65 1.915.614 3.036.8 5.724 1.414Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M28.335 35v-3.333A6.667 6.667 0 0 0 21.668 25H8.335a6.667 6.667 0 0 0-6.667 6.667V35m36.666 0v-3.333a6.667 6.667 0 0 0-5-6.45m-6.666-20a6.667 6.667 0 0 1 0 12.917m-5.001-6.467a6.667 6.667 0 1 1-13.333 0 6.667 6.667 0 0 1 13.333 0Z"
  }));
};
exports.SpotUser = SpotUser;
SpotUser.displayName = "SpotUser";